import { render, staticRenderFns } from "./modTradePwd.vue?vue&type=template&id=a8ee9434&scoped=true&"
import script from "./modTradePwd.vue?vue&type=script&lang=js&"
export * from "./modTradePwd.vue?vue&type=script&lang=js&"
import style0 from "./modTradePwd.vue?vue&type=style&index=0&id=a8ee9434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee9434",
  null
  
)

export default component.exports